/**
 * BrowserCheck notifies if user has an older browser.
 * https://github.com/browser-update/browser-update/wiki/Details-on-configuration
 */
import browserUpdate from 'browser-update';

export const plugin = {
    name: 'browser-check',

    install () {
        browserUpdate({
            required: {
                e: 90,      // Edge
                i: 12,      // IE 11 unsupported
                f: 78,      // Firefox ESR
                o: -3,      // Opera
                s: 12.0,    // Safari
                c: 90       // Chrome
            },
            test: false,
            insecure: false
        });
    }
};

export default plugin;
